var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Rodizios - Kits","p-read-link":"kits.read.one","p-create-link":"kits.create","p-name":"kits"}})}
var staticRenderFns = []

export { render, staticRenderFns }